import _ from 'lodash';
import { useRouter } from 'next/compat/router';
import useDispensaryMenuSections from 'src/dispensary/hooks/use-dispensary-menu-sections';

export default function useCarousel() {
  const { menuSections } = useDispensaryMenuSections();

  const router = useRouter();
  const { carouselId } = router?.query;

  const carousel = _.find(menuSections, [`id`, carouselId]);

  return { carousel };
}
